"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_USER_EMAILS = void 0;
exports.TEST_USER_EMAILS = [
    "@mg.tp-qa-mail.com",
    "@tp-automatedtesting.com",
    "@yopmail.com",
];
//# sourceMappingURL=constants.js.map